import gql from 'graphql-tag';

export const channelWebhookSummaries = gql(`
  query channelWebhookSummaries($channelId: UUID!) {
    webhooksOnChannel(
      channelId: $channelId
      pagination: { start: 0, perPage: 500 }
    ) {
      items {
        _id
        webhook {
          _id
          name
          url
          status
        }
      }
    }
  }
`);
